import axios from 'axios'
import toast from './toast'

function errorResponseHandler (error) {
  // if the user is not authenticated, redirect to the home/login page
  if (error.response && error.response.status === 401) {
    window.location.href = '/login'
  }
  return Promise.reject(error)
}

// apply interceptor on response
axios.interceptors.response.use(
  response => response,
  errorResponseHandler,
)

export default errorResponseHandler
